import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[lazyLoad]',
})
export class LazyLoadDirective implements OnInit, OnDestroy {
  @Output() visible = new EventEmitter<void>();
  private observer: IntersectionObserver | null = null;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        // If element becomes visible
        if (entry.isIntersecting) {
          this.visible.emit();
          // Stop observing once visible
          this.observer?.disconnect();
        }
      },
      {
        // Element is considered visible when 10% is in viewport
        threshold: 0.1,
      },
    );

    // Start observing the element
    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
